import { useShallowDeep } from "@/hooks/zustand";
import type { Calc } from "../types";
import { useCalculator } from "./useCalculator";

export const useCalculatorRequestData =
  (): Calc.Api.CalculatorUpdateRequest => {
    return useCalculator(useShallowDeep((state) => state.getRequestData()));
  };
